var chopstickToggle = function() {
    // The toggle is called with the '.js-toggle' class and one or more data-targets.
    // Use the 'is-hidden' class to hide your elements".
    // Added the 'click on document' for dynamic generated toggles.
    $(document).on('click', '.js-toggle', function (e) {
        // The trigger
        var trigger = $(this);

        // Prevent the default action on links
        e.preventDefault();

        // Split the targets if multiple
        var targets = trigger.data('target').replace(' ', '').split(',');

        // Loop trough targets and toggle the 'is-hidden' class
        for (var i = targets.length - 1; i >= 0; i--) {
            if(targets[i]){
                // Toggle the 'is-hidden' class
                $(targets[i]).toggleClass('is-hidden');
            }
        }

        // Add an 'is-toggled' class to the trigger.
        // Use this class to style your icons, active states, etc.
        trigger.toggleClass('is-toggled');

        return false;
    });
}
